import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Youtube,
  Rss,
  Phone,
  Mail,
  MessageCircle,
} from "lucide-react";
import { BRAND, FOOTER_COLUMNS, EBROCHURES } from "@/data/content";
import { Link } from "react-router-dom";
import { resolveAssetPath } from "@/lib/assets";

const FOOTER_ROUTES = {
  Home: "/",
  "About Us": "/about",
  "Group Tours": "/group-tours",
  "Tours At a Glance": "/tours-at-a-glance",
  "All Group Tours": "/all-group-tours",
  "Speciality Tours": "/category/speciality-tours",
  "Economy Tours": "/economy-tours",
  Experiences: "/category/customized-holidays",
  "Corporate Travel": "/category/corporate-travel",
  Asia: "/world?q=Asia",
  "Forex & Insurance": "/forex-insurance",
  "Royal Academy": "/royal-academy",
  "Guest Corner": "/guest-corner",
  "How to Book": "/how-to-book",
  "Tour Leaders": "/tour-leaders",
  "Online Payment": "/online-payment",
  "Guest Feedback": "/guest-feedback",
  Testimonials: "/testimonials",
  "Privacy Policy": "/privacy-policy",
  "Terms & Condition": "/terms-and-conditions",
  "Terms & Conditions": "/terms-and-conditions",
  "Partner with Us": "/partner-with-us",
  "Join as PSA": "/join-as-psa",
  "Join as GSA": "/join-as-gsa",
  Franchisee: "/franchisee",
  "Franchisee/PSA Online": "/franchisee-psa-online",
  "Travel Agent": "/travel-agent",
  Careers: "/careers",
  Blog: "/india",
  "eBrochure 2026": "/ebrochure-2026",
  Awards: "/awards",
  Videos: "/videos",
};

const FooterLink = ({ label }) =>
  FOOTER_ROUTES[label] ? (
    <Link to={FOOTER_ROUTES[label]} className="hover:text-[var(--yellow)] transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{label}</Link>
  ) : (
    <a href="#" className="hover:text-[var(--yellow)] transition-colors">{label}</a>
  );

const SOCIAL_LINKS = [
  { icon: Facebook, href: "https://www.facebook.com/RoyaltoursGorakhpur", label: "facebook" },
  { icon: Twitter, href: "https://x.com/RoyalTourTrave3", label: "twitter" },
  { icon: Linkedin, href: "https://in.linkedin.com/in/royal-holidays-507020234", label: "linkedin" },
  { icon: Instagram, href: "https://www.instagram.com/royal.holidayz", label: "instagram" },
  { icon: Youtube, href: "https://www.youtube.com/@royalholidayspvt", label: "youtube" },
  { icon: Rss, href: "https://in.pinterest.com/RoyaltoursGorakhpur/", label: "pinterest" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0a1a30] text-gray-300">
      {/* Top columns */}
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-2">
          <div className="text-white font-bold text-sm mb-4">Main Links</div>
          <ul className="space-y-2.5 text-[13px]">
            {FOOTER_COLUMNS.mainLinks.map((l) => (
              <li key={l}>
                <FooterLink label={l} />
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-white font-bold text-sm mb-4">Guest Services Links</div>
          <ul className="space-y-2.5 text-[13px]">
            {FOOTER_COLUMNS.guestServices.map((l) => (
              <li key={l}>
                <FooterLink label={l} />
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <Link to="/partner-with-us" className="block text-white font-bold text-sm mb-4 hover:text-[var(--yellow)]" data-testid="footer-link-partner-with-us">Partner with Us / Career</Link>
          <ul className="space-y-2.5 text-[13px]">
            {FOOTER_COLUMNS.partner.map((l) => (
              <li key={l}>
                <FooterLink label={l} />
              </li>
            ))}
          </ul>
          <div className="text-white font-bold text-sm mb-3 mt-6">Company</div>
          <ul className="space-y-2.5 text-[13px]">
            {FOOTER_COLUMNS.company.map((l) => (
              <li key={l}>
                {l === "About Us" ? (
                  <Link to="/about" className="hover:text-[var(--yellow)] transition-colors" data-testid="footer-about-link">{l}</Link>
                ) : (
                  <FooterLink label={l} />
                )}
              </li>
            ))}
            <li>
              <Link to="/contact" className="hover:text-[var(--yellow)] transition-colors" data-testid="footer-contact-link">Contact Us</Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-white font-bold text-sm mb-4">Support</div>
          <ul className="space-y-2.5 text-[13px]">
            <li>
              <Link to="/contact" className="hover:text-[var(--yellow)] transition-colors">
                Contact us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-[var(--yellow)] transition-colors">
                Guest Helpline
              </Link>
            </li>
            <li>
              <a href="#faq" className="hover:text-[var(--yellow)] transition-colors">
                FAQs
              </a>
            </li>
            <li className="flex items-center gap-2 pt-1">
              <Phone className="w-3.5 h-3.5 text-[var(--yellow)]" />
              <span>
                {BRAND.phone}{" "}
                <span className="text-[var(--yellow)] font-semibold">
                  (Toll Free-Royal)
                </span>
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-3.5 h-3.5 text-[var(--yellow)]" />
              <span>
                {BRAND.phoneAlt}{" "}
                <span className="text-[var(--yellow)] font-semibold">
                  (Toll Free-Select)
                </span>
              </span>
            </li>
            <li className="flex items-center gap-2 text-pink-400 font-semibold">
              <MessageCircle className="w-3.5 h-3.5" />
              <span>Exclusive For NRI: {BRAND.nri}</span>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-3.5 h-3.5 text-[var(--yellow)]" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[var(--yellow)]">
                {BRAND.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-white font-bold text-sm mb-4 scroll-mt-28" id="brochures">eBrochures</div>
          <div className="grid grid-cols-2 gap-3">
            {EBROCHURES.map((b) => (
              <Link
                to="/ebrochure-2026"
                key={b.title}
                data-testid={`brochure-${b.title.toLowerCase().replace(/[^a-z]/g, "")}`}
                className="relative group rounded-md overflow-hidden aspect-[4/3]"
              >
                <img
                  src={resolveAssetPath(b.image)}
                  alt={b.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-2 text-white text-[11px] font-semibold">
                  {b.title}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Social + download row */}
      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <div className="text-white font-semibold text-sm mb-3">Follow Us</div>
            <div className="flex items-center gap-2.5">
              {SOCIAL_LINKS.map(({ icon: Icon, href, label }, i) => (
                <a
                  key={i}
                  href={href}
                  data-testid={`social-${i}`}
                  aria-label={label}
                  target="_blank"
                  rel="noreferrer"
                  className="w-8 h-8 rounded-md bg-white/10 hover:bg-[var(--yellow)] hover:text-[var(--navy)] flex items-center justify-center transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-6">
            <div>
              <div className="text-[11px] text-gray-400">Payment Methods</div>
              <div className="flex items-center gap-2 mt-1">
                <span className="bg-white text-blue-700 font-bold text-[10px] px-2 py-1 rounded">VISA</span>
                <span className="flex items-center gap-0.5">
                  <span className="w-4 h-4 rounded-full bg-red-500 inline-block" />
                  <span className="w-4 h-4 rounded-full bg-yellow-400 -ml-1.5 inline-block" />
                </span>
              </div>
            </div>
            <div>
              <div className="text-[11px] text-gray-400">Download Our App</div>
              <div className="flex items-center gap-2 mt-1">
                <span className="bg-black border border-white/15 text-white text-[10px] px-2 py-1 rounded">GET IT ON Google Play</span>
                <span className="bg-black border border-white/15 text-white text-[10px] px-2 py-1 rounded">App Store</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom row */}
      <div className="bg-black/40 border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-[12px] text-gray-400">
          <div>
            © 2010–{new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </div>
          <div className="flex gap-5">
            <Link to="/awards" className="hover:text-[var(--yellow)]" data-testid="footer-awards">Awards</Link>
            <Link to="/privacy-policy" className="hover:text-[var(--yellow)]" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-[var(--yellow)]" data-testid="footer-terms">Terms & Condition</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
